export default {
  api: {
    url: 'https://graphql.wnwd.com'
  },
  frontegg: {
    baseUrl: 'https://login.wnwd.com',
    clientId: '0065206a-693f-4421-a3a8-9adfaa8c4826',
    playgroundAppId: '136eb59c-368b-4275-bf8c-391472a3961b',
    abuTaggingAppId: '9b684324-dc41-4d11-946a-1c9aebb3e8b9',
  },
};
